var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNairaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05072 17.252L6.05072 13.1007L5 13.1007L5 11.857L6.05072 11.857L6.05072 10.6469L5 10.6469L5 9.40321L6.05072 9.40321L6.05072 5.25195L8.89493 5.25195L10.308 9.40321L11.9565 9.40322L11.9565 5.25195L13.9674 5.25195L13.9674 9.40322L15 9.40322L15 10.6469L13.9674 10.6469L13.9674 11.857L15 11.857L15 13.1007L13.9674 13.1007L13.9674 17.252L11.1051 17.252L9.6558 13.1007L8.06159 13.1007L8.06159 17.252L6.05072 17.252ZM8.06159 11.857L9.25724 11.857L8.85869 10.6469L8.02536 10.6469L8.06159 11.857ZM12.0109 14.6301L12.1014 14.6301L12.029 13.1007L11.5399 13.1007L12.0109 14.6301ZM7.98913 9.40321L8.49638 9.40321L7.97101 7.78977L7.89855 7.78977L7.98913 9.40321ZM11.1594 11.857L11.9928 11.857L11.9565 10.6469L10.7428 10.6469L11.1594 11.857Z",
    fill: "#0D1126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaIcon);
export default __webpack_public_path__ + "static/media/nairaIcon.bf21f7862841dfb4be707ab220737370.svg";
export { ForwardRef as ReactComponent };